import cx from 'classnames2';
import React from 'react';

import { useListTableContext } from '../ListTable';

import styles from './ListTable.Cell.module.scss';

export interface IListTableCellProps {
  className?: string;
  dataTest?: string;
}

export const ListTableCell: React.FC<IListTableCellProps> = ({ dataTest, children, className }) => {
  const context = useListTableContext();

  return (
    <div
      className={cx(styles.cell, className, context.variant === 'condensed' && styles.variantCondensed)}
      data-test={dataTest}
    >
      {children}
    </div>
  );
};
